


























import Tab from '../components/Tab.vue';
import Tabs from '../components/Tabs.vue';
import TelcoFormGeneral from './TelcoFormGeneral.vue';
import TelcoFormStock from './TelcoFormStock.vue';
import TelcoFormApn from './TelcoFormApn.vue';
import TelcoFormPlanes from './TelcoFormPlanes.vue';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    Tab,
    Tabs,
    TelcoFormGeneral,
    TelcoFormStock,
    TelcoFormApn,
    TelcoFormPlanes,
  },
})
export default class TelcoEditarForm extends Vue {
  @Prop({ default: null }) telcoid: any;
  @Prop({ default: null }) telconame: any;
  @Prop({ default: null }) telcoprefix: any;
  @Prop({ default: null }) usuarioID: any;
  @Prop({ default: null }) estadoSelected: any;
}
